export const tdist = {
    // 110000:["汕头市潮南区司马浦","110000"],
    // 220000:["其他区潮南区司马浦","220000"],
    // 330000:["丹江口市潮南区司马浦","330000"],
    // 440000:["城区潮南区司马浦","420300"],
    // 550000:["运城市潮南区司马浦","550000"],
    // 770000: ["盐湖区潮南区司马浦","770000"],
    // 880000: ["长海县潮南区司马浦","880000"],
    // 990000: ["开发区潮南区司马浦","990000"],
    // 130000: ["金洲区潮南区司马浦","130000"],
    // 120000: ["夏县潮南区司马浦","120000"]
    // 110000: ['北京市', '110000'],
    // 120000: ['天津市', '120000'],
    // 130000: ['河北省', '130000'],
    // 140000: ['山西省', '140000'],
    // 150000: ['内蒙古自治区', '150000'],
    // 210000: ['辽宁省', '210000'],
    // 220000: ['吉林省', '220000'],
    // 230000: ['黑龙江省', '230000'],
    // 310000: ['上海市', '310000'],
    320000: ['江苏省', '320000'],



    321000: ['扬州市', '321000'],

    321002: ['广陵区', '321002'],
    321003: ['邗江区', '321003'],
    321004: ['江都区', '321004'],
    321005: ['宝应县', '321005'],
    321006: ['仪征市', '321006'],
    321007: ['高邮市', '321007'],





    // 330000: ['浙江省', '330000'],
    // 340000: ['安徽省', '340000'],
    // 350000: ['福建省', '350000'],
    // 360000: ['江西省', '360000'],
    // 370000: ['山东省', '370000'],
    // 410000: ['河南省', '410000'],
    // 420000: ['湖北省', '420000'],
    // 430000: ['湖南省', '430000'],
    // 440000: ['广东省', '440000'],
    // 450000: ['广西壮族自治区', '450000'],
    // 460000: ['海南省', '460000'],
    // 500000: ['重庆市', '500000'],
    // 510000: ['四川省', '510000'],
    // 520000: ['贵州省', '520000'],
    // 530000: ['云南省', '530000'],
    // 440300: ['深圳市', '440300'],
    // 440400: ['珠海市', '440400'],
    // 440500: ['汕头市', '440500'],
    // 440600: ['佛山市', '440600'],
    // 440700: ['江门市', '440700'],
    // 110100: ['北京市', '110100'],
    // 110200: ['县', '110200'],
    // 120100: ['天津市', '120100'],
    // 120200: ['县', '120200'],
    // 130100: ['石家庄市', '130100'],
    // 130200: ['唐山市', '130200'],
    // 130300: ['秦皇岛市', '130300'],
    // 130400: ['邯郸市', '130400'],
    // 130500: ['邢台市', '130500'],
    // 130600: ['保定市', '130600'],
    // 130700: ['张家口市', '130700'],
    // 130800: ['承德市', '130800'],
    // 130900: ['沧州市', '130900'],
    // 131000: ['廊坊市', '131000'],
    // 131100: ['衡水市', '131100'],
    // 139000: ['省直辖县', '139000'],
    // 140100: ['太原市', '140100'],
    // 140200: ['大同市', '140200'],
    // 140300: ['阳泉市', '140300'],
    // 140400: ['长治市', '140400'],
    // 621100: ['定西市', '620000'],
    // 621102: ['安定区', '621100'],
    // 440514: ['潮南区', '440514'],
    // 440507: ['龙湖区', '440507'],
    // 440511: ['金平区', '440511'],
    // 440512: ['濠江区', '440512'],
    // 440513: ['潮阳区', '440513'],

}

tdist.getLev1 = function () {
    for (var t = [], e = 1; e < 100; e++) {
        var i = "0000";
        i = e < 10 ? "0" + e + i : e + i;
        var n = this[i];
        "undefined" != typeof n && t.push({
            id: i,
            text: n[0]
        })
    }
    return t
}
tdist.getLev2 = function (t) {
    if ("" == t)
        return [];
    for (var e = [], i = 1; i < 100; i++) {
        var n = t.substr(0, 2);
        n += i < 10 ? "0" + i + "00" : i + "00";
        var r = this[n];
        "undefined" != typeof r && e.push({
            id: n,
            text: r[0]
        })
    }
    return e
}
tdist.getLev3 = function (t) {
    if ("" == t)
        return [];
    for (var e = [], i = 1; i < 100; i++) {
        var n = t.substr(0, 4);
        n += i < 10 ? "0" + i : i;
        var r = this[n];
        "undefined" != typeof r && e.push({
            id: n,
            text: r[0]
        })
    }
    return e
}
